import { formatDate } from '@angular/common';
import { Directive, inject, Injectable } from '@angular/core';
import { Nullable } from '@core/helpers/nullable';
import { LanguagesWithRegions } from '@core/types/LanguagesWithRegions';
import { TuiDay, TuiValueTransformer } from '@taiga-ui/cdk';
import { tuiInputDateOptionsProvider } from '@taiga-ui/kit';

type From = Nullable<TuiDay>;
type To = Nullable<string>;

/**
 * Преобразовывает дату в виде строки "YYYY-MM-DD" в TuiDate и обратно.
 */
@Injectable({
  providedIn: 'root',
})
class HyphenedStringToDateTransformer extends TuiValueTransformer<From, To> {
  fromControlValue(controlValue: To): From {
    if (controlValue === null) {
      return controlValue;
    }
    const controlValueAsDate =
      typeof controlValue === 'string' ? new Date(controlValue) : controlValue;

    return TuiDay.fromLocalNativeDate(controlValueAsDate);
  }

  toControlValue(componentValue: From): To {
    const date = componentValue?.toLocalNativeDate();

    return date
      ? formatDate(date, 'yyyy-MM-dd', LanguagesWithRegions.RU_RU)
      : null;
  }
}

@Directive({
  selector: 'tui-textfield[xHyphenedStringTuiDateTransformer]',
  standalone: true,
  providers: [
    tuiInputDateOptionsProvider(() => ({
      valueTransformer: inject(HyphenedStringToDateTransformer),
    })),
  ],
})
export class HyphenedStringTuiDateTransformerDirective {}
